export const messages = {
  en: {
    purchaseApplyManage: {
      title: 'Purchase Application Management',
      queryConditions: 'Query Conditions',
      orderNumber: 'Order Number',
      selectStatus: 'Select Status',
      applicantName: 'Applicant Name',
      search: 'Search',
      purchaseApplication: 'Purchase Application',
      addPurchase: 'Add Purchase',
      applicationNumber: 'Application Number',
      applicant: 'Applicant',
      endUser: 'End User',
      items: 'Items',
      applicationTime: 'Application Time',
      referencePrice: 'Reference Price',
      approvalStatus: 'Approval Status',
      operations: 'Operations',
      view: 'View',
      workflowDiagram: 'Workflow Diagram',
      cancel: 'Cancel',
      confirmOperation: 'Confirm Operation',
      confirmCancel: 'Confirm Cancel',
      confirmDelete: 'Are you sure to cancel the application?',
      editPurchase: 'Edit Purchase Application',
      orderStatus: 'Order Status',
      requiredSelect: 'Required, please select order status',
      save: 'Save'
    }
  },
  zh: {
    purchaseApplyManage: {
      title: '采购申请管理',
      queryConditions: '查询条件',
      orderNumber: '订单号',
      selectStatus: '请选择状态',
      applicantName: '申请人姓名',
      search: '查询',
      purchaseApplication: '采购申请',
      addPurchase: '新增采购',
      applicationNumber: '申请单号',
      applicant: '申请人',
      endUser: '使用人',
      items: '物品',
      applicationTime: '申请时间',
      referencePrice: '参考价格',
      approvalStatus: '审批状态',
      operations: '操作',
      view: '查看',
      workflowDiagram: '流程图',
      cancel: '取消',
      confirmOperation: '确认操作',
      confirmCancel: '确认取消',
      confirmDelete: '确定取消申请?',
      editPurchase: '修改采购申请',
      orderStatus: '订单状态',
      requiredSelect: '必填，请选择订单状态',
      save: '保存'
    }
  }
}